import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const RequirementsWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const RequirementSemiBold = styled.span`
  font-weight: 500;
`;

export const TitleWithTooltip = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TooltipIconWrapper = styled.span`
  display: flex;
  cursor: pointer;
`;
